import React from 'react';
import { render } from 'react-dom';
import PropTypes from 'prop-types';

import './scratch-card.scss';
class ScratchCard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.lastPoint = null;
    this.touchStart = this.touchStart.bind(this);
    this.touchMove = this.touchMove.bind(this);
    this.mouseMove = this.mouseMove.bind(this);
    this.state = {
      isCompleted: false,
      showBackgraound: false,
    };
  }

  componentDidMount() {
    const canvas = this.canvas;
    canvas.width = canvas?.parentElement?.offsetWidth;
    canvas.height = canvas?.parentElement?.offsetHeight;

    canvas.addEventListener('mousedown', this.touchStart);
    canvas.addEventListener('touchstart', this.touchStart);
    canvas.addEventListener('mousemove', this.mouseMove);
    canvas.addEventListener('touchmove', this.touchMove);

    this.ctx = canvas.getContext('2d');

    this.brush = new Image();
    this.brush.src = require('../../../assets/brush.png');

    this.cover = new Image();
    this.cover.crossOrigin = 'Anonymous';
    this.cover.src = this.props.foregroundImage;
    this.cover.onload = () => {
      this.ctx.drawImage(this.cover, 0, 0, canvas.width, canvas.height);
      this.setState({ showBackgraound: true });
    };
  }

  componentWillUnmount() {
    const canvas = this.canvas;
    canvas.removeEventListener('mousedown', this.touchStart);
    canvas.removeEventListener('touchstart', this.touchStart);
    canvas.removeEventListener('mousemove', this.touchMove);
    canvas.removeEventListener('touchmove', this.touchMove);
  }

  getPosition(event) {
    let target = this.canvas;
    let offsetX = 0;
    let offsetY = 0;

    if (target.offsetParent !== undefined) {
      while ((target = target.offsetParent)) {
        offsetX += target.offsetLeft;
        offsetY += target.offsetTop;
      }
    }

    const x = (event.pageX || event.touches[0].clientX) - offsetX;
    const y = (event.pageY || event.touches[0].clientY) - offsetY;
    return { x, y };
  }

  touchStart(event) {
    this.lastPoint = this.getPosition(event);
    this.ctx.globalCompositeOperation = 'destination-out';
  }

  getFilledInPixels(stride) {
    if (!stride || stride < 1) stride = 1;
    var pixels = this.ctx.getImageData(
      0,
      0,
      this.props.width,
      this.props.height
    );
    var total = pixels.data.length / stride;
    var count = 0;
    for (var i = 0; i < pixels.data.length; i += stride) {
      if (parseInt(pixels.data[i], 10) === 0) count++;
    }
    return Math.round((count / total) * 100);
  }

  mouseMove(event) {
    if (this.lastPoint) {
      this.touchMove(event);
    }
  }

  touchMove(event) {
    const ctx = this.ctx;
    var percent = this.getFilledInPixels(32);
    if (percent >= this.props.completeAt && !this.state.isCompleted) {
      this.setState({
        isCompleted: true,
      });
      this.cover.src = this.props.backgroundImage;
      this.cover.onload = () =>
        this.ctx.drawImage(
          this.cover,
          0,
          0,
          this.props.width,
          this.props.height
        );
      this.props.onComplete();
    } else {
      const a = this.lastPoint;
      const b = this.getPosition(event);
      const dist = Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
      const angle = Math.atan2(b.x - a.x, b.y - a.y);
      const offsetX = this.brush.width / 2;
      const offsetY = this.brush.height / 2;

      for (let x, y, i = 0; i < dist; i++) {
        x = a.x + Math.sin(angle) * i - offsetX;
        y = a.y + Math.cos(angle) * i - offsetY;
        ctx.drawImage(this.brush, x, y);
      }
      this.lastPoint = b;
    }
  }

  render() {
    const { showBackgraound } = this.state;
    return (
      <div
        className="scratch-card--container"
        style={{ width: this.props.width, height: this.props.height }}
      >
        <canvas
          className="scratch-card--canvas"
          ref={el => (this.canvas = el)}
        />
        {showBackgraound && <div>{this.props.children}</div>}
      </div>
    );
  }
}

ScratchCard.propTypes = {
  foregroundImage: PropTypes.string,
  backgroundImage: PropTypes.string,
  completeAt: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  onComplete: PropTypes.func,
};

ScratchCard.defaultProps = {
  foregroundImage: '',
  backgroundImage: '',
  completeAt: 10,
  width: 300,
  height: 300,
  onComplete: () => {},
};

export default ScratchCard;
